// extracted by mini-css-extract-plugin
module.exports = {"meal":"mealItem_meal__94kTl","description":"mealItem_description__2wJVr","price":"mealItem_price__3QOYF"};